<script setup>
import { computed } from "vue";
import {
  Apple,
  Archive,
  Link,
  Share2,
  Users,
  ArrowDown,
  ArrowRight,
  ArrowUp,
  ArrowUpLeft,
  ArrowUpRight,
  ArrowDownLeft,
  ArrowDownRight,
  CornerUpLeft,
  CornerUpRight,
  RotateCw,
  ArrowUpDown,
  AudioLines,
  BadgeCheck,
  Bed,
  Building2,
  Camera,
  Car,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  CircleAlert,
  CircleCheck,
  CircleDot,
  CircleHelp,
  CircleParking,
  CircleUserRound,
  CircleX,
  ClipboardList,
  Clock3,
  CloudDownload,
  Compass,
  Construction,
  Copy,
  Download,
  ExternalLink,
  FileText,
  Flag,
  FlagTriangleRight,
  Fuel,
  GripVertical,
  Handshake,
  House,
  Inbox,
  Landmark,
  Lightbulb,
  LocateFixed,
  Lock,
  LockOpen,
  Mail,
  Map,
  MapPin,
  MapPinCheck,
  MapPinPlus,
  MapPinned,
  Menu,
  MessageSquare,
  Minus,
  MoreVertical,
  Moon,
  Navigation,
  Navigation2,
  Pencil,
  Phone,
  Pin,
  Plus,
  RadioTower,
  Rocket,
  RotateCcw,
  Route,
  RouteOff,
  Ruler,
  Satellite,
  Save,
  ScanLine,
  Search,
  Send,
  ShieldCheck,
  ShowerHead,
  Smartphone,
  Target,
  Trash2,
  TriangleAlert,
  Truck,
  Undo2,
  Upload,
  Utensils,
  Volume2,
  Waypoints,
  Weight,
  Wifi,
  WifiOff,
  X,
  ZoomIn,
} from "@lucide/vue";

const props = defineProps({
  name: { type: String, required: true },
  size: { type: [Number, String], default: 20 },
  strokeWidth: { type: [Number, String], default: 2 },
  label: { type: String, default: "" },
});

const icons = {
  archive: Archive,
  link: Link,
  share: Share2,
  users: Users,
  home: House,
  menu: Menu,
  apple: Apple,
  "arrow-down": ArrowDown,
  "arrow-up": ArrowUp,
  "arrow-up-left": ArrowUpLeft,
  "arrow-up-right": ArrowUpRight,
  "arrow-right": ArrowRight,
  "arrow-down-left": ArrowDownLeft,
  "arrow-down-right": ArrowDownRight,
  "turn-left": CornerUpLeft,
  "turn-right": CornerUpRight,
  roundabout: RotateCw,
  "arrow-up-down": ArrowUpDown,
  audio: AudioLines,
  "badge-check": BadgeCheck,
  bed: Bed,
  building: Building2,
  camera: Camera,
  car: Car,
  check: Check,
  "chevron-down": ChevronDown,
  "chevron-left": ChevronLeft,
  "chevron-right": ChevronRight,
  "circle-alert": CircleAlert,
  "circle-check": CircleCheck,
  "circle-dot": CircleDot,
  "circle-help": CircleHelp,
  parking: CircleParking,
  user: CircleUserRound,
  "circle-x": CircleX,
  clipboard: ClipboardList,
  clock: Clock3,
  "cloud-download": CloudDownload,
  compass: Compass,
  construction: Construction,
  copy: Copy,
  download: Download,
  external: ExternalLink,
  file: FileText,
  flag: Flag,
  finish: FlagTriangleRight,
  fuel: Fuel,
  grip: GripVertical,
  handshake: Handshake,
  inbox: Inbox,
  landmark: Landmark,
  idea: Lightbulb,
  locate: LocateFixed,
  lock: Lock,
  unlock: LockOpen,
  mail: Mail,
  map: Map,
  pin: MapPin,
  "pin-check": MapPinCheck,
  "pin-plus": MapPinPlus,
  "map-pinned": MapPinned,
  message: MessageSquare,
  minus: Minus,
  more: MoreVertical,
  moon: Moon,
  navigation: Navigation,
  directions: Navigation2,
  edit: Pencil,
  phone: Phone,
  pinned: Pin,
  plus: Plus,
  radio: RadioTower,
  rocket: Rocket,
  reset: RotateCcw,
  route: Route,
  "route-off": RouteOff,
  ruler: Ruler,
  satellite: Satellite,
  save: Save,
  scan: ScanLine,
  search: Search,
  send: Send,
  shield: ShieldCheck,
  shower: ShowerHead,
  smartphone: Smartphone,
  target: Target,
  trash: Trash2,
  warning: TriangleAlert,
  truck: Truck,
  undo: Undo2,
  upload: Upload,
  food: Utensils,
  volume: Volume2,
  waypoints: Waypoints,
  weight: Weight,
  wifi: Wifi,
  "wifi-off": WifiOff,
  x: X,
  "zoom-in": ZoomIn,
};

const icon = computed(() => icons[props.name] || CircleHelp);
</script>

<template>
  <component
    :is="icon"
    :size="size"
    :stroke-width="strokeWidth"
    :aria-hidden="label ? undefined : 'true'"
    :aria-label="label || undefined"
    :role="label ? 'img' : undefined"
    focusable="false"
  />
</template>
